import { render, staticRenderFns } from "./AddPersonal.vue?vue&type=template&id=0d8f7cfd&scoped=true&"
import script from "./AddPersonal.vue?vue&type=script&lang=js&"
export * from "./AddPersonal.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonal.vue?vue&type=style&index=0&id=0d8f7cfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f7cfd",
  null
  
)

export default component.exports